<template>
  <div>
    <el-container class="padding">
      <el-form inline>
        <el-form-item label="經銷商">
          <selectCompany :id.sync="company_id" @onSelect="onSelectCompany" />
        </el-form-item>
      </el-form>
    </el-container>

    <div class="text-right">
      <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="size" layout="sizes, prev, pager, next" :total="invoices.count" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
    <el-table :data="invoices.rows" style="width: 100%" :row-class-name="statusClass">
      <el-table-column prop="AssetNo" label="機台編號" />
      <el-table-column prop="OrderNo" label="訂單編號" width="370" />
      <el-table-column label="開立時間" width="200">
        <template slot-scope="scope">
          {{ scope.row.updated_at | dateTimeFilter }}
        </template>
      </el-table-column>
      <el-table-column prop="Period" label="期別" width="80" />
      <el-table-column label="發票號碼" width="150">
        <template slot-scope="scope"> {{ scope.row.Front }}-{{ scope.row.Number }} </template>
      </el-table-column>
      <el-table-column label="開立類型" width="100">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.detail.invoiceType | invoiceTypeFilter }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="開立狀態" width="100" prop="Status">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status ? 'success' : 'danger'">
            {{ scope.row.Status ? '未開立' : '已開立' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="動作" width="100">
        <template v-if="scope.row.detail" slot-scope="scope">
          <el-button round type="primary" size="mini" @click="handleDetail(scope.row)">明細</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-right">
      <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="size" layout="sizes, prev, pager, next" :total="invoices.count" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog title="發票明細" :visible.sync="dialogVisible" width="30%">
      <h3>品名: {{ invoiceDetail.product_name }}</h3>
      <h3>單價: {{ invoiceDetail.unit_price }}</h3>
      <h3>支付方式: {{ invoiceDetail.pay_type | paytypeFilter }}</h3>
      <h3>交易時間: {{ invoiceDetail.sale_time }}</h3>
      <h3>開立方式: {{ invoiceDetail.invoice_type | invoiceTypeFilter }}</h3>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogVisible = false">確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getInvoiceHasInvoiced, deleteInvoices, getInvoice, getInvoices } from '@/api/invoice';
import selectCompany from '@/components/select/companies';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
const methods = {
  async onSelectCompany() {
    this.invoices = await getInvoices({
      company_id: this.company_id,
    });
    this.currentPage = 1;
  },
  async init() {
    this.selected = [];
  },
  statusClass({ row, index }) {
    switch (row.Status) {
      case 0:
        return 'danger';
      default:
        return '';
    }
  },
  handleSelectionChange(rows) {
    this.selected = rows;
  },
  async deleteInvoices() {
    const data = await deleteInvoices(this.selected);
    if (data) {
      this.$message({
        message: '成功',
        type: 'success',
      });
    }
    this.init();
  },
  async handleDetail(row) {
    this.dialogVisible = true;
    try {
      const data = await getInvoice(row.id);
      this.invoiceDetail = data;
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  },

  async handleSizeChange(size) {
    this.size = size;
    this.invoices = await getInvoices({
      company_id: this.company_id,
      size: this.size,
    });
  },
  async handleCurrentChange(page) {
    this.invoices = await getInvoices({
      company_id: this.company_id,
      page,
      size: this.size,
    });
  },
};
export default {
  components: {
    selectCompany,
  },
  filters: {
    dateTimeFilter(datetime) {
      const t = dayjs(datetime).tz('Asia/Taipei').format('YYYY-MM-DD HH:mm:ss');
      return t;
    },
    paytypeFilter(type) {
      const map = {
        cash: '現金',
        easycard: '悠遊卡',
        icash: 'icash',
        ipass: '一卡通',
        creditcard: '信用卡',
        line: 'LINE Pay',
        jkos: '街口支付',
        ali: '支付寶',
        gama: '橘子支',
        wechart: '微信支付',
        pi: 'Pi錢包',
        wallet: '玉山錢包',
        pxpay: '全支付',
        family: '全盈支付',
      };
      return map[type] ? map[type] : 'N/A';
    },
    invoiceTypeFilter(type) {
      const map = {
        carrier: '載具',
        donate: '愛心捐贈',
      };
      return map[type] ? map[type] : '紙本列印';
    },
  },
  data() {
    return {
      invoices: [],
      selected: [],
      invoiceDetail: {},
      invoiceSale: {},
      invoice: {},
      dialogVisible: false,
      company_id: null,
      currentPage: 1,
      size: 10,
    };
  },
  created() {
    this.init();
  },
  methods,
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .danger {
  background: #5858583b;
}

.padding {
  padding: 1rem;
}
</style>
